import Vue from "vue";
import blurOn from "./blur-on";
import ImageFallBack from "./image-fallback";
import Loader from "./loader-directive";

Vue.directive("image-fallback", ImageFallBack);
Vue.directive("loader", Loader);
Vue.directive("blur-on", blurOn);
